var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c("rb-dummy-skeleton", {
        staticClass: "rb-product-tile__attributes --attributes",
      })
    : _c(
        "div",
        { staticClass: "rb-product-tile__attributes" },
        _vm._l(_vm.attributesMap, function (attr, i) {
          return _c("rb-product-tile-attributes-element", {
            key: i,
            attrs: { attribute: attr },
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }